// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2fVyC","productName":"Table_productName__3hg_P"};